import React, { useEffect, useState } from "react";

// project-import
import { showToast } from "../sweet-alert/Sweetalert";

// third-party
import { useSelector } from "react-redux";
import { calculateAverageRating } from "../../utils/product";

function EbookStarRating({ reviews, onViewUserRatings }) {
  // State variable
  const [starRatings, setStarRatings] = useState(0);

  // Reading data from property
  const ratingsData = reviews || [];

  // Local variable
  // calculating the percentage ratio of starRating
  let ratings = Number((starRatings - Math.floor(starRatings)) * 100).toFixed(
    2
  );

  // Constant variables
  const ratingsCount =
    ratingsData
      ? ratingsData.length
      : null;

  // Dynamic Css for star Rating Start
  const halfIconDynamicStyle = {
    "--width": `${ratings}%`,
    "--rating-percent": `${100 - ratings}%`,
  };
  // Dynamic Css for star Rating End

  useEffect(() => {
    try {
      setStarRatings(calculateAverageRating(reviews));
    } catch (error) {
      console.log("40:: Error calculating star ratings:", error);
      setStarRatings(0);
      showToast("error", "Error calculating star ratings. Please try again.", true, "bottom-right", false, true, 5000);
    }
  }, [ratingsCount]);

  const handleViewUserRatings = () => {
    try {
      if (onViewUserRatings) {
        onViewUserRatings();
      }
    } catch (error) {

    }
  }

  return (
    <div>
      <div className="rating eduvibe-course-rating-stars clickable fs-15" onClick={handleViewUserRatings}>
        {[...Array(5)].map((item, index) => {
          const givenRating = index + 1;
          return (
            <i
              key={index}
              className={
                starRatings >= givenRating
                  ? "icon-Star"
                  : starRatings > givenRating - 1 && starRatings < givenRating
                    ? " icon-Star-half "
                    : " off icon-Star"
              }
              style={halfIconDynamicStyle}
            ></i>
          );
        })}
      </div>
      <span className="rating-count fs-15 text overflow-hidden p-0">
        ({starRatings > 0 ? starRatings + " Avg. Ratings" : "0 Rating"})
      </span>
    </div>
  );
}

export default EbookStarRating;
